import LegalLayout from './components/LegalLayout';

export default function TermsPage() {
  return (
    <LegalLayout title="Пользовательское соглашение" lastUpdated="12 августа 2026">
      <section>
        <h2 className="text-lg font-semibold text-foreground-950 mb-4">1. Общие положения</h2>
        <p>Настоящее Пользовательское соглашение (далее — Соглашение) регулирует отношения между Индивидуальным предпринимателем Галиуллиным Маратом Гарифулловичем (далее — Администратор) и пользователем сайта aigam.ru (далее — Пользователь).</p>
        <p className="mt-3">Используя сайт aigam.ru и все связанные с ним сервисы, Пользователь подтверждает свое согласие с условиями настоящего Соглашения. Если Пользователь не согласен с условиями Соглашения, использование сайта и его сервисов должно быть немедленно прекращено.</p>
      </section>

      <section>
        <h2 className="text-lg font-semibold text-foreground-950 mb-4">2. Термины и определения</h2>
        <ul className="list-disc pl-5 space-y-2">
          <li><strong>Сайт</strong> — интернет-ресурс, расположенный по адресу aigam.ru.</li>
          <li><strong>Сервисы</strong> — программные продукты и услуги, предоставляемые Администратором через Сайт, включая, но не ограничиваясь: Telegram заявки, AI-рассыльщик, перехват конкурентов, интеграции, рассылка под ключ, заявки под ключ.</li>
          <li><strong>Пользователь</strong> — любое физическое или юридическое лицо, использующее Сайт и/или Сервисы.</li>
          <li><strong>Контент</strong> — любые материалы, размещённые на Сайте, включая текст, графику, изображения, аудио, видео, программное обеспечение.</li>
        </ul>
      </section>

      <section>
        <h2 className="text-lg font-semibold text-foreground-950 mb-4">3. Предмет Соглашения</h2>
        <p>Администратор предоставляет Пользователю право использовать Сайт и Сервисы на условиях, определённых настоящим Соглашением. Право использования предоставляется в рамках функциональных возможностей Сайта и выбранного тарифного плана.</p>
        <p className="mt-3">Все объекты интеллектуальной собственности, размещённые на Сайте, являются собственностью Администратора или его партнёров. Использование Контента вне рамок функциональности Сайта, включая копирование, распространение, модификацию, требует письменного согласия правообладателя.</p>
      </section>

      <section>
        <h2 className="text-lg font-semibold text-foreground-950 mb-4">4. Права и обязанности Пользователя</h2>
        <p>Пользователь вправе:</p>
        <ul className="list-disc pl-5 space-y-2 mt-3">
          <li>использовать Сайт и Сервисы в соответствии с их функциональным назначением;</li>
          <li>получать консультации и техническую поддержку по вопросам работы Сервисов;</li>
          <li>ознакомиться с актуальной информацией о тарифах и услугах на Сайте.</li>
        </ul>
        <p className="mt-4">Пользователь обязуется:</p>
        <ul className="list-disc pl-5 space-y-2 mt-3">
          <li>не использовать Сайт и Сервисы для нарушения законодательства РФ;</li>
          <li>не распространять спам, вредоносное ПО, материалы, нарушающие права третьих лиц;</li>
          <li>не предпринимать действий, способных нарушить нормальную работу Сайта и Сервисов;</li>
          <li>не пытаться получить несанкционированный доступ к данным других пользователей или серверной инфраструктуре;</li>
          <li>не использовать автоматизированные средства для сбора информации с Сайта без письменного разрешения Администратора.</li>
        </ul>
      </section>

      <section>
        <h2 className="text-lg font-semibold text-foreground-950 mb-4">5. Права и обязанности Администратора</h2>
        <p>Администратор вправе:</p>
        <ul className="list-disc pl-5 space-y-2 mt-3">
          <li>изменять функциональность Сайта и Сервисов, обновлять программное обеспечение;</li>
          <li>временно ограничивать доступ Пользователя к Сервисам в случае нарушения Соглашения;</li>
          <li>направлять Пользователю информационные сообщения о работе Сервисов;</li>
          <li>отказывать в предоставлении Сервисов лицам, нарушающим настоящее Соглашение.</li>
        </ul>
        <p className="mt-4">Администратор обязуется:</p>
        <ul className="list-disc pl-5 space-y-2 mt-3">
          <li>обеспечивать функционирование Сайта и Сервисов в соответствии с заявленными возможностями;</li>
          <li>соблюдать конфиденциальность персональных данных Пользователя в соответствии с Политикой конфиденциальности;</li>
          <li>предоставлять техническую поддержку в рабочие часы (Пн–Пт, 10:00–19:00 МСК).</li>
        </ul>
      </section>

      <section>
        <h2 className="text-lg font-semibold text-foreground-950 mb-4">6. Ответственность сторон</h2>
        <p>Администратор не несёт ответственности за:</p>
        <ul className="list-disc pl-5 space-y-2 mt-3">
          <li>невозможность доступа к Сайту и Сервисам по причинам, находящимся вне контроля Администратора;</li>
          <li>действия третьих лиц, направленные на нарушение работы Сайта;</li>
          <li>прямые и косвенные убытки, возникшие в результате использования или невозможности использования Сервисов;</li>
          <li>контент, размещённый Пользователем или полученный через Сервисы от третьих лиц;</li>
          <li>убытки, связанные с изменением законодательства или действиями государственных органов.</li>
        </ul>
        <p className="mt-3">Пользователь несёт ответственность за:</p>
        <ul className="list-disc pl-5 space-y-2 mt-3">
          <li>достоверность предоставляемых данных при регистрации и использовании Сервисов;</li>
          <li>соблюдение законодательства при использовании Сервисов, включая законодательство о рекламе, защите персональных данных, авторских правах;</li>
          <li>любые действия, совершённые под его учётной записью.</li>
        </ul>
      </section>

      <section>
        <h2 className="text-lg font-semibold text-foreground-950 mb-4">7. Ограничение ответственности Администратора</h2>
        <p>Сервисы предоставляются на условиях «как есть». Администратор не гарантирует полное соответствие Сервисов конкретным целям и ожиданиям Пользователя. Администратор не гарантирует бесперебойную работу Сервисов и не несёт ответственности за прямые или косвенные убытки, возникшие из-за технических сбоев, перебоев в работе интернет-соединения, действий или бездействия провайдеров и иных третьих лиц.</p>
      </section>

      <section>
        <h2 className="text-lg font-semibold text-foreground-950 mb-4">8. Интеллектуальная собственность</h2>
        <p>Все права на Сайт, Сервисы, их элементы и оформление, включая программное обеспечение, дизайн, тексты, изображения, логотипы, принадлежат Администратору или его партнёрам. Пользователю предоставляется ограниченное, неисключительное, непередаваемое право использования Сервисов в соответствии с настоящим Соглашением.</p>
        <p className="mt-3">Пользователь не вправе: декомпилировать, дизассемблировать, модифицировать программное обеспечение Сервисов; создавать производные работы на основе Сервисов; удалять или изменять уведомления об авторских правах и иных правах интеллектуальной собственности.</p>
      </section>

      <section>
        <h2 className="text-lg font-semibold text-foreground-950 mb-4">9. Ссылки на сторонние ресурсы</h2>
        <p>Сайт и Сервисы могут содержать ссылки на сторонние веб-сайты. Администратор не контролирует содержание этих сайтов и не несёт ответственности за их содержание, политику конфиденциальности или практики. Переход по таким ссылкам осуществляется Пользователем на свой страх и риск.</p>
      </section>

      <section>
        <h2 className="text-lg font-semibold text-foreground-950 mb-4">10. Изменение Соглашения</h2>
        <p>Администратор вправе в любое время изменять настоящее Соглашение. Изменения вступают в силу с момента публикации новой редакции на Сайте. Продолжение использования Сайта и Сервисов после внесения изменений означает согласие Пользователя с новой редакцией Соглашения.</p>
      </section>

      <section>
        <h2 className="text-lg font-semibold text-foreground-950 mb-4">11. Разрешение споров</h2>
        <p>Все споры и разногласия, возникающие из настоящего Соглашения, подлежат разрешению путём переговоров. Если стороны не достигнут соглашения в течение 30 (тридцати) календарных дней, спор подлежит передаче в судебные органы Российской Федерации по месту регистрации Администратора.</p>
      </section>

      <section>
        <h2 className="text-lg font-semibold text-foreground-950 mb-4">12. Заключительные положения</h2>
        <p>Настоящее Соглашение регулируется законодательством Российской Федерации. Если какое-либо положение Соглашения будет признано недействительным, это не влияет на действительность остальных положений. Вопросы, не урегулированные настоящим Соглашением, решаются в соответствии с законодательством РФ.</p>
        <p className="mt-3">По всем вопросам, связанным с настоящим Соглашением, Пользователь может обращаться по адресу электронной почты: aydar@aigam.ru.</p>
      </section>
    </LegalLayout>
  );
}